import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useObrasInformacoesGeraisPagination
 */

type State = {
  estOrg: PaginationProperties,
  atividadesObra: PaginationProperties,
  especificidadesObra: PaginationProperties,
  indicadoresObra: PaginationProperties,
  obraArquivos: PaginationProperties,
  obraInformacoes: PaginationProperties,
};

type Actions = {
  estOrgSetter: SetPaginationProperties,
  atividadesObraSetter: SetPaginationProperties,
  especificidadesObraSetter: SetPaginationProperties,
  indicadoresObraSetter: SetPaginationProperties,
  obraArquivosSetter: SetPaginationProperties,
  obraInformacoesSetter: SetPaginationProperties,
};

export const useObrasInformacoesGeraisPagination = create<State & Actions>((set, get) => ({
  estOrg: InitializePaginationProperties({ rowsPerPage: 100 }),
  estOrgSetter: InitializeSetPaginationProperties(set, 'estOrg'),
  atividadesObra: InitializePaginationProperties({ rowsPerPage: 100 }),
  atividadesObraSetter: InitializeSetPaginationProperties(set, 'atividadesObra'),
  especificidadesObra: InitializePaginationProperties({ rowsPerPage: 100 }),
  especificidadesObraSetter: InitializeSetPaginationProperties(set, 'especificidadesObra'),
  indicadoresObra: InitializePaginationProperties({ rowsPerPage: 100 }),
  indicadoresObraSetter: InitializeSetPaginationProperties(set, 'indicadoresObra'),
  obraArquivos: InitializePaginationProperties({ rowsPerPage: 100 }),
  obraArquivosSetter: InitializeSetPaginationProperties(set, 'obraArquivos'),
  obraInformacoes: InitializePaginationProperties({ rowsPerPage: 100 }),
  obraInformacoesSetter: InitializeSetPaginationProperties(set, 'obraInformacoes'),
}));